// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_user_user_routing_module_ts":"8e911223a6e5ab0e","src_app_license_license_routing_module_ts":"9eeb9dafc389bd6c"}[chunkId] + ".js";
};